export const environment = {
  baseUrl: "https://coronaresources-api.onrender.com",
  // baseUrl: "http://localhost:5000",
};
